const RESOURCE_NAME = '/reports';
import restApi from "@/api/rest-api-object";

export default axios => ({
    ...restApi(axios, RESOURCE_NAME),
    getSystemReportData(id, from=0, to=0, objType, objId, params) {
        return axios.get(`${RESOURCE_NAME}/${id}/${from}/${to}/${objType}/${objId}`, {params});
    },
    getSystemReportDataFile(id, from=0, to=0, objType, objId, format, params) {
        return axios.get(`${RESOURCE_NAME}/${id}/${from}/${to}/${objType}/${objId}/export/${format}`, {params});
    },
    // exec(type, format, data, params) {
    //     return axios.post(`${RESOURCE_NAME}/`, data, {params});
    // },
    export(id, format, data, params) {
        return axios.post(`${RESOURCE_NAME}/${id}/export/${format}`, data, {params});
    },
});